import { render, staticRenderFns } from "./LifeEventSelect.vue?vue&type=template&id=89573918&"
import script from "./LifeEventSelect.vue?vue&type=script&lang=js&"
export * from "./LifeEventSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports